import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import Reveal from './Reveal';

export default function FinalCTA() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal variant="scale" duration={900}>
          <div className="relative overflow-hidden rounded-[32px] bg-white border border-black/5 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.18)] p-10 md:p-16">
            <div className="absolute -top-32 -right-32 w-[400px] h-[400px] rounded-full bg-gradient-to-br from-[#dbeafe] to-transparent blur-3xl opacity-80 drift" />
            <div className="absolute -bottom-20 -left-20 w-[350px] h-[350px] rounded-full bg-gradient-to-tr from-[#e6f0fa] to-transparent blur-3xl opacity-60 drift-2" />
            <div className="relative grid lg:grid-cols-12 gap-10 items-center">
              <div className="lg:col-span-8">
                <div className="text-[12px] tracking-[0.2em] uppercase font-semibold text-[#1e6cb0] mb-4">
                  Facciamo il primo passo insieme
                </div>
                <h2 className="heading-mega text-[36px] md:text-[58px] text-neutral-900">
                  Iniziamo il tuo sito.<br />
                  <span className="text-[#1e6cb0]">Da 25&euro;/mese</span>, prezzo onesto, niente sorprese.
                </h2>
              </div>
              <div className="lg:col-span-4 lg:text-right">
                <a
                  href="https://wa.me/393383463712?text=Ciao!%20Ho%20visto%20il%20tuo%20sito%20B-WEB%20e%20vorrei%20richiedere%20il%20mio%20sito%20web."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-[#1e6cb0] text-white px-8 py-5 rounded-full font-semibold text-[17px] btn-glow"
                >
                  Scrivimi su WhatsApp <ArrowUpRight className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
